import { useEffect, useState } from 'react';
import { api } from './api';

/** État public de l'ouverture de la suite (`GET /plateforme/statut`, 27/09/2026). */
export interface StatutOuverture {
  paidSignupOpen: boolean;
  signupMode: 'OPEN' | 'INVITE' | 'CLOSED';
  signupOpen: boolean;
  invitationRequired: boolean;
  signupClosedMessage: string;
}

/**
 * Repli PRUDENT DANS LE BON SENS en cas de panne : inscriptions ouvertes (une
 * panne ne doit pas afficher « fermé » à tort) — le serveur refusera de toute
 * façon si ce n'est pas le cas, avec un message qui le dit.
 */
const REPLI: StatutOuverture = {
  paidSignupOpen: false,
  signupMode: 'OPEN',
  signupOpen: true,
  invitationRequired: false,
  signupClosedMessage: '',
};

let enVol: Promise<StatutOuverture> | null = null;

/** Mémorisé pour la page : ces réglages changent quelques fois par an. */
export function lireOuverture(): Promise<StatutOuverture> {
  enVol ??= api
    .get<StatutOuverture>('/plateforme/statut')
    .then((s) => ({ ...REPLI, ...s }))
    .catch(() => REPLI);
  return enVol;
}

/** `null` tant que l'état n'est pas connu : ne rien promettre avant de savoir. */
export function useOuverture(): StatutOuverture | null {
  const [statut, setStatut] = useState<StatutOuverture | null>(null);
  useEffect(() => {
    let actif = true;
    void lireOuverture().then((s) => actif && setStatut(s));
    return () => {
      actif = false;
    };
  }, []);
  return statut;
}

/** Messages des refus d'ouverture, communs aux deux portes d'inscription. */
export function messageOuverture(code: string | undefined, message: string): string | null {
  if (code === 'SIGNUP_CLOSED' || code === 'SIGNUP_CODE_REQUIRED' || code === 'SIGNUP_CODE_INVALID') {
    return message;
  }
  return null;
}
